import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import { AuthenticatedUserRepositoryService } from '../services/authenticated-user-repository.service';
import { DeliveryStepsService } from '../services/delivery-steps.service';
import { AddressModel } from '../../shared/models/address.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs/Subscription';

@AutoUnsubscribe()
@Component({
    selector: 'payment-delivery',
    templateUrl: './payment.delivery.component.html',
    styleUrls: ['./../payment.component.scss']
})
export class PaymentDeliveryComponent implements OnInit, OnDestroy {
    public addresses = [];
    public loading = false;
    @Input() identificationReady;
    @Input() deliveryAddressPending;
    @Input() deliveryAddressActive;
    @Input() deliveryAddressReady;
    @Input() deliveryFreightPending;
    @Input() deliveryFreightActive;
    @Input() deliveryFreightReady;
    @Output('deliveryAddressReady') eventDeliveryAddressReady: EventEmitter<any> = new EventEmitter();
    @Output('deliveryFreightReady') eventDeliveryFreightReady: EventEmitter<any> = new EventEmitter();

    authenticatedUserServiceChangedUser: Subscription;
    authenticatedUserServiceResetedUser: Subscription;
    deliveryStepsLoadingAddresses: Subscription;
    deliveryStepsLoadedAddresses: Subscription;
    deliveryStepsLoadAddresses: Subscription;

    constructor(
        protected deliverySteps: DeliveryStepsService,
        protected authenticatedUserService: AuthenticatedUserRepositoryService
    ) { }

    ngOnInit() {
        this.authenticatedUserServiceChangedUser = this.authenticatedUserService
            .changedUser$
            .subscribe(user => {
                if (user !== null) {
                    this.deliveryStepsLoadAddresses = this.deliverySteps
                        .loadAddresses()
                        .subscribe((addresses: Array<AddressModel>) => {
                            if (addresses.length >= 1) {
                                this.deliverySteps.setSelectedAddress(addresses[0]);
                                this.onDeliveryAddressReady(addresses[0]);
                            }
                        });
                }
            });
        this.authenticatedUserServiceResetedUser = this.authenticatedUserService.resetedUser$.subscribe(() => {
            this.addresses = [];
        });
        this.deliveryStepsLoadingAddresses = this.deliverySteps.loadingAddresses$.subscribe(() => {
            this.loading = true;
        });
        this.deliveryStepsLoadedAddresses = this.deliverySteps.loadedAddresses$.subscribe((addresses: Array<AddressModel>) => {
            this.loading = false;
            this.addresses = addresses;
        });
    }
    ngOnDestroy() {
        // Overrided by AutoUnsubscribe
    }

    public onDeliveryAddressReady(obj) {
        this.eventDeliveryAddressReady.emit(obj);
    }
    public onDeliveryFreightReady(obj) {
        this.eventDeliveryFreightReady.emit(obj);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/payment/delivery/payment.delivery.component.ts